import React from 'react';
import PropTypes from 'prop-types';
import { withRouteData } from 'react-static';
import { get } from 'lodash';

import Section from '../../common/Section';
import ArticleBody from './ArticleBody';
import FeaturedImage from './FeaturedImage';
import EmbeddablePlayer from './EmbeddablePlayer';
import ShareButtons from './ShareButtons';
import Recommendation from './Recommendation';
import ArticleSubheader from './ArticleSubheader';

import styled from 'styled-components';
import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';
import ArticleAuthor from './ArticleAuthor';

const BodyContent = styled.div`
  max-width: calc(var(--fr) * 40);
  padding: 0 1rem;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  position: relative;
`;

const Header = styled.div`
  position: relative;
  padding-top: calc(10 * var(--fr));

  ${media.large`
    padding-top: calc(15 * var(--fr));
  `};
`;

const HeaderContent = styled.div`
  max-width: ${props => (props.fullWidthHeadline ? 'unset' : 'calc(var(--fr) * 40)')};
  padding: 0 1rem;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
  position: relative;
`;

const Player = styled.div`
  max-width: calc(var(--fr) * 40);
  margin: auto;
`;

const Intro = styled.section`
  p {
    font-size: var(--fs-focus);
    font-weight: 500;
  }

  .articleSubheader {
    text-transform: uppercase;
    font-size: var(--fs-s);
    font-weight: 500;
    color: var(--c-manatee);
    margin-bottom: 1rem;
    ${legacyType('s', 'label', { uppercase: true })};
  }
`;

const ArticleContent = ({ content, path }) => {
  const { featuredImage, body, title, category, featuredPlayer, fullWidthHeadline, author } =
    content;

  return (
    <Section>
      <Header>
        {featuredImage && <FeaturedImage featuredImage={featuredImage} />}
        <HeaderContent fullWidthHeadline={fullWidthHeadline} id="articleContent">
          <Intro>
            <div className="articleSubheader">
              <ArticleSubheader category={category} />
            </div>
            <h1>{title}</h1>
          </Intro>
          {featuredPlayer && (
            <Player>
              <EmbeddablePlayer
                id={get(featuredPlayer, 'fields.playlistId')}
                type={get(featuredPlayer, 'fields.playerType')}
              />
            </Player>
          )}
          <ShareButtons path={path} />
        </HeaderContent>
      </Header>
      <BodyContent>
        {get(author, 'fields') && <ArticleAuthor author={author.fields} />}
        <ArticleBody body={body} />
      </BodyContent>
      <Recommendation prev={content.prevArticle} next={content.nextArticle} />
    </Section>
  );
};

ArticleContent.propTypes = {
  content: PropTypes.object,
  path: PropTypes.string,
};

export default withRouteData(ArticleContent);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/ArticleContent.js